import call from './call';
import {push} from 'connected-react-router';
import {SHOW_MSG} from "../types";
import languages from "../language/languages";
import {MAIN_ROUTE} from "../components/Main/routes";

export default (form) => async (dispatch,getState) =>
{
    const onResult= (result) =>
    {
        if(result)
        {
            if(result[1].success)
            {
                let state=getState();
                if(state.auth.logged)
                    dispatch(push(MAIN_ROUTE));
                else
                    dispatch(push('/'));
                dispatch({type: SHOW_MSG, payload: {message: languages[state.auth.language].processOk,type:'success'}});
            }
        }
    }
    dispatch(call("UserService/changePassword",form,onResult));
};